/**
 * Arquivo: src/services/drive.ts
 * Versão: 5.6.1
 * Data: 08/10/2026
 */
import { apiBlob, apiJson } from './api'

export type ModuloAnexo = 'LANCAMENTO' | 'TRANSFERENCIA'
export type Anexo = {
  id:string
  modulo:ModuloAnexo
  registro_id:string
  nome_arquivo:string
  mime_type?:string
  tamanho?:number
  web_url?:string
  storage_provider?:string
  storage_item_id?:string
  criado_em?:string
}

export async function listarAnexos(baseId:string, modulo:ModuloAnexo, registroId:string):Promise<Anexo[]> {
  const r = await apiJson(`/attachments?base_id=${encodeURIComponent(baseId)}&modulo=${encodeURIComponent(modulo)}&registro_id=${encodeURIComponent(registroId)}`)
  return r.items || []
}

export async function abrirAnexo(baseId:string, modulo:ModuloAnexo, registroId:string, anexoId:string) {
  const janela = window.open('', '_blank')
  try {
    const blob = await apiBlob(`/attachments/${encodeURIComponent(anexoId)}/content?base_id=${encodeURIComponent(baseId)}&modulo=${encodeURIComponent(modulo)}&registro_id=${encodeURIComponent(registroId)}`)
    const url = URL.createObjectURL(blob)
    if (janela) {
      janela.location.replace(url)
    } else {
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noreferrer'
      document.body.appendChild(link)
      link.click()
      link.remove()
    }
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000)
  } catch (e) {
    janela?.close()
    throw e
  }
}

export async function enviarAnexo(baseId:string, modulo:ModuloAnexo, registroId:string, file:File) {
  const form = new FormData()
  form.append('base_id',baseId)
  form.append('modulo',modulo)
  form.append('registro_id',registroId)
  form.append('file',file)
  return apiJson('/attachments',{method:'POST',body:form})
}
export async function excluirAnexo(baseId:string, modulo:ModuloAnexo, registroId:string, anexoId:string) {
  return apiJson(`/attachments/${encodeURIComponent(anexoId)}?base_id=${encodeURIComponent(baseId)}&modulo=${encodeURIComponent(modulo)}&registro_id=${encodeURIComponent(registroId)}`,{method:'DELETE'})
}

export async function gerarBackup(baseId:string) {
  return apiJson('/backup',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({base_id:baseId})})
}

export async function iniciarConexaoOneDrive(baseId:string):Promise<string> {
  const r = await apiJson('/oauth/microsoft/connect', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({base_id:baseId}),
  })
  if (!r?.authorize_url) throw new Error('A autorização do OneDrive não retornou uma URL válida.')
  return String(r.authorize_url)
}

